import { render, staticRenderFns } from "./AdModal.vue?vue&type=template&id=4d5ef770&scoped=true"
import script from "./AdModal.vue?vue&type=script&lang=js"
export * from "./AdModal.vue?vue&type=script&lang=js"
import style0 from "./AdModal.vue?vue&type=style&index=0&id=4d5ef770&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5ef770",
  null
  
)

export default component.exports